import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class DocumentPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'editDocument':
        return this.permissions.update

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default DocumentPolicy
